import { ArrowRight, BookOpen, Calculator, CircleQuestionMark as HelpCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function RemodelingEstimateCta() {
  return <section id="remodelingestimatecta" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 lg:py-28 border-t border-border overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Main Action and Link Columns */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-semibold tracking-tight text-foreground leading-tight">
              Start your Brookhaven kitchen renovation project
            </h2>

            <p className="mt-5 text-base sm:text-lg text-muted-foreground max-w-2xl font-default leading-relaxed">
              Schedule an in-home walkthrough to review your layout ideas, finish preferences, and budget expectations — we will follow up to discuss your project.
            </p>

            {/* Primary Call to Action */}
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-medium px-8 h-12 shadow-sm rounded-md">
                <Link to="/ContactRequestAnEstimatePage" onClick={e => {
                const target = document.getElementById('estimaterequestform');
                if (target) {
                  e.preventDefault();
                  target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              }}>
                  <span>Request an Estimate</span>
                  <ArrowRight className="size-4 ml-1.5" />
                </Link>
              </Button>
            </div>

            {/* Related Services Row */}
            <div className="mt-12 pt-8 border-t border-border">
              <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">
                Related Services
              </div>
              <div className="flex flex-wrap items-center gap-3 sm:gap-6">
                <Link to="#" className="inline-flex items-center text-sm font-medium text-foreground hover:text-primary transition-colors py-1 underline-offset-4 hover:underline">
                  Bathroom Remodeling
                </Link>
                <span className="text-border hidden sm:inline" aria-hidden="true">
                  •
                </span>
                <Link to="#" className="inline-flex items-center text-sm font-medium text-foreground hover:text-primary transition-colors py-1 underline-offset-4 hover:underline">
                  Whole-Home Remodeling
                </Link>
              </div>
            </div>

            {/* Guides & FAQ Links */}
            <div className="mt-8 pt-6 border-t border-border/60">
              <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">
                Planning Resources
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Link to="#" className="flex items-center gap-2 text-sm text-foreground/90 hover:text-primary transition-colors group">
                  <Calculator className="size-4 text-primary shrink-0 transition-transform group-hover:scale-110" />
                  <span>Remodeling Cost Guide</span>
                </Link>
                <Link to="#" className="flex items-center gap-2 text-sm text-foreground/90 hover:text-primary transition-colors group">
                  <BookOpen className="size-4 text-primary shrink-0 transition-transform group-hover:scale-110" />
                  <span>Remodeling Planning Guide</span>
                </Link>
                <Link to="#" className="flex items-center gap-2 text-sm text-foreground/90 hover:text-primary transition-colors group">
                  <HelpCircle className="size-4 text-primary shrink-0 transition-transform group-hover:scale-110" />
                  <span>FAQ</span>
                </Link>
              </div>
            </div>
          </div>

          {/* Kitchen Renovation Photography Grid */}
          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="relative rounded-lg overflow-hidden border border-border bg-card shadow-sm aspect-4/5">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_island_custom_cabinetry_brookhaven.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_island_custom_cabinetry_brookhaven.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_island_custom_cabinetry_brookhaven.webp-wvc-sizes" alt="Custom kitchen renovation featuring marble waterfall island and handcrafted cabinetry in Brookhaven" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
            </div>

            <div className="space-y-4 pt-6 sm:pt-8">
              <div className="relative rounded-lg overflow-hidden border border-border bg-card shadow-sm aspect-4/5">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_range_backsplash_renovation_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_range_backsplash_renovation_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/kitchen_range_backsplash_renovation_detail.png-wvc-sizes" alt="Kitchen remodeling detail with brass hardware, custom range hood, and tile backsplash" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}